<h1>{{'faqTitle' | translate}}</h1>
<div class="row topRow">
  <div class="col-sm-12">
    <faq-form [faq]="selectedFaq" (faqAdded)="closeBottomSheet()"></faq-form>
  </div>
</div>